import { render, staticRenderFns } from "./create-payment-form.vue?vue&type=template&id=705dcb36&"
import script from "./create-payment-form.vue?vue&type=script&lang=js&"
export * from "./create-payment-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports